import axios from 'axios';

const baseURL = import.meta?.env?.VITE_API_BASE_URL || '/api';

const api = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    // Reduce noisy logs in production
    if (import.meta?.env?.MODE !== 'production') {
      console.log('🚀 API Request:', config.method?.toUpperCase(), config.url);
    }
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    if (import.meta?.env?.MODE !== 'production') {
      console.error('❌ API Request Error:', error);
    }
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    if (import.meta?.env?.MODE !== 'production') {
      console.log('✅ API Response:', response.status, response.config.url);
    }
    return response;
  },
  (error) => {
    if (import.meta?.env?.MODE !== 'production') {
      console.error('❌ API Response Error:', error.message, error.config?.url);
    }
    // Redirect to login on 401
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
